import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Heading,
  Image,
  NeoColor,
  Spacing,
  Stack,
  Text,
} from "@noom/wax-component-library";

import { NeoButton } from "@/components";
import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { useTrackEvent } from "@/hooks";

import { BaseInterstitial } from "../core";

const QUESTION_ID = "connectHealthRecordsIntro";

const ConnectHealthRecordsIntro: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
}) => {
  const { trackIdentifiedPageViewed } = useTrackEvent();
  const { t } = useTranslation();

  useEffect(() => {
    trackIdentifiedPageViewed(QUESTION_ID);
  }, []);

  return (
    <BaseInterstitial
      backgroundColor={NeoColor.blue.skyLight}
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      questionId={QUESTION_ID}
    >
      <Box position="relative" marginTop={Spacing[2]}>
        <Image
          alt=""
          src="/assets/img/connect-health-records-hero.png"
          width="100%"
        />
      </Box>
      <Stack
        spacing={Spacing[4]}
        marginTop="-80px"
        position="relative"
        zIndex={1}
      >
        <Heading
          fontSize="24px"
          fontWeight={500}
          lineHeight="32px"
          textAlign="center"
        >
          {t("connectHealthRecordsIntro.heading")}
        </Heading>
        <Box alignItems="flex-start" display="flex" gap="12px">
          <Image
            alt="Diamond bullet"
            marginTop="4px"
            src="/assets/img/diamond-tarocco.svg"
          />
          <Text>{t("connectHealthRecordsIntro.bullet1")}</Text>
        </Box>
        <Box alignItems="flex-start" display="flex" gap="12px">
          <Image
            alt="Diamond bullet"
            marginTop="4px"
            src="/assets/img/diamond-tarocco.svg"
          />
          <Text>{t("connectHealthRecordsIntro.bullet2")}</Text>
        </Box>
      </Stack>
      <Box display="flex" justifyContent="center" marginTop={Spacing[2]}>
        <NeoButton onClick={() => onClickNext(null)}>
          {t("connectHealthRecordsIntro.ctaText")}
        </NeoButton>
      </Box>
    </BaseInterstitial>
  );
};

export const Q_CONNECT_HEALTH_RECORDS_INTRO: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: () => true,
  component: ConnectHealthRecordsIntro,
};
